// API Configuration
export const API_BASE_URL = 'https://qs9maczlpl.execute-api.ap-south-1.amazonaws.com';
export const BLOGS_ENDPOINT = `${API_BASE_URL}/blogs`;

// Content
export const ABOUT_TEXT = {
  name: 'NAUSHER ALI',
  title: 'Software Engineer & Creative Developer',
  tagline: 'Transforming Ideas into Digital Solutions',
  description1: 'Experienced software engineer with a passion for developing innovative programs that expedite the efficiency and effectiveness of organizational success. Well-versed in technology and writing code to create systems that are reliable and user-friendly.',
  description2: 'Skilled leader who has the proven ability to motivate, educate and manage a team of professionals to build software programs and effectively track changes. Confident communicator, strategic thinker, and innovative creator to develop software that is customized to meet a company\'s organizational needs.',
};

export const STATS = [
  { number: '5+', label: 'Years of Experience', color: 'from-blue-400 to-blue-600' },
  { number: '50+', label: 'Projects Completed', color: 'from-purple-400 to-purple-600' },
  { number: '30+', label: 'Happy Clients', color: 'from-pink-400 to-pink-600' },
];

export const SKILLS = [
  { name: 'HTML5', percentage: 95, color: 'from-blue-500 to-blue-400', delay: '0s' },
  { name: 'CSS3', percentage: 85, color: 'from-purple-500 to-purple-400', delay: '0.1s' },
  { name: 'JAVASCRIPT', percentage: 65, color: 'from-yellow-500 to-yellow-400', delay: '0.2s' },
  { name: 'UX/UI', percentage: 85, color: 'from-pink-500 to-pink-400', delay: '0.3s' },
];

export const ACCENT_COLORS = [
  'from-blue-500 to-purple-500',
  'from-purple-500 to-pink-500',
  'from-pink-500 to-red-500',
  'from-emerald-500 to-cyan-500',
  'from-yellow-500 to-orange-500',
  'from-indigo-500 to-blue-500',
];
